import { createSlice } from "@reduxjs/toolkit";
import React from "react";

const LabelTypeLogic = createSlice({
    name: "LabelTypeLogic",
    initialState: {
      labelTypeArray: [],
    },
    reducers: {
      addLabelItem: (state, action) => {
        const newValue = action.payload;
        if (!state.labelTypeArray.includes(newValue)) {
          state.labelTypeArray.push(newValue);
        }
      },
      clearLabels: (state) => {
        state.labelTypeArray = [];
      },
    },
  });
  
  export const { addLabelItem, clearLabels } = LabelTypeLogic.actions;
  export default LabelTypeLogic.reducer;
  